import React, { useEffect, useState } from "react";
import { Card, Col, Table } from "reactstrap";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { baseUrl } from "../../../../Utils/Baseurl/Baseurl";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { useNavigate } from "react-router-dom";

interface CustomJwtPayload {
  id: string;
}

interface TaxData {
  id: number | string;
  taxpercent: string;
}

export default function ViewTax() {
  const navigate = useNavigate();
  const [taxpercent, setTaxpercent] = useState<TaxData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchTaxDetails = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("User is not logged in!");
          setLoading(false);
          return;
        }

        const decoded = jwtDecode<CustomJwtPayload>(token);
        const userId = decoded.id;

        if (!userId) {
          toast.error("Invalid token, user ID not found!");
          setLoading(false);
          return;
        }

        // Fetch tax details
        const response = await axios.get(`${baseUrl}tax/getalltax`);
        console.log(response.data, "API Response");

        if (response.data && Array.isArray(response.data.data)) {
          setTaxpercent(response.data.data);
        } else {
          setTaxpercent([]);
        }
      } catch (error) {
        console.error("Error fetching tax details:", error);
        toast.error("Failed to fetch tax records!");
      } finally {
        setLoading(false);
      }
    };

    fetchTaxDetails();
  }, []);
  const handleAdd=async()=>{
    navigate('/admiro/tax')
  }

  return (
    <Col sm={12}>
      <Card>
        <CommonCardHeader title="Tax Details" />
        <div className="table-responsive">
            
        <div className="d-flex justify-content-end p-3">
  <button className="btn btn-secondary" onClick={handleAdd}>
    Add Tax
  </button>
</div>

          {loading ? (
            <p className="text-center p-3">Loading...</p>
          ) : (
            <Table striped bordered>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Tax ID</th>
                  <th>Tax Percentage</th>
                </tr>
              </thead>
              <tbody>
                {taxpercent.length > 0 ? (
                  taxpercent.map((tax, index) => (
                    <tr key={tax.id}>
                      <td>{index + 1}</td>
                      <td>{tax.id}</td>
                      <td>{tax.taxpercent}%</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center">
                      No tax records found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>
      </Card>
    </Col>
  );
}
